import React from "react";
import Blogs from "../containers/blogs/Blogs";
import "./Page.scss";

const BlogsPage = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <h1>My Blogs</h1>
        </div>
        <Blogs />
      </div>
    </div>
  );
};

export default BlogsPage;



